module.exports = __webpack_public_path__ + "img/cricklewood.661a72e3.png";